// extracted by mini-css-extract-plugin
export default {"headerWrap":"index_headerWrap_5jLO6","subNav":"index_subNav_jFCIg","main":"index_main_vsKSg","footerWrap":"index_footerWrap_nmMwg"};